import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Col,
  Row,
  message,
  Select,
  InputNumber,
  Radio,
} from "antd";
import { API_METHODS, ACCOUNT_TYPE } from "../../../constants";
import useApi from "../../../hooks/useApi";
const { TextArea } = Input;

function AddAccount(props) {
  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi("/config/account", null, API_METHODS.POST);
  const [editResponse, editRequest] = useApi(
    `/config/account/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT
  );

  useEffect(() => {
    if (response.data) {
      close(true);
      message.success("Account added successfully.");
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      message.success("Account updated successfully.");
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord]);

  const handleOk = () => {
    form.validateFields().then((values) => {
      if (selectedRecord) {
        editRequest(values);
      } else {
        request(values, API_METHODS.POST);
      }
    });
  };

  const handleCancel = () => {
    close();
  };

  return (
    <Modal
      title="Add Account"
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="accountType"
              label="Account Type"
              rules={[{ required: true, message: "Account Type is required." }]}
            >
              <Select
                placeholder="Select Option"
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {ACCOUNT_TYPE.map((option) => (
                  <Select.Option key={option.key} value={option.key}>
                    {option.value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="accountName"
              label="Account Name"
              rules={[
                { required: true, message: "Account Name is required." },
                {
                  max: 200,
                  message: "Account Name should be maximum of 200 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          {/* <Col span={8}>
            <Form.Item name="openingBalance" label="Opening Balance">
              <InputNumber />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="debit_credit_radio" label="">
              <Radio.Group>
                <Radio value="Debit">Debit</Radio>
                <Radio value="Credit">Credit</Radio>
              </Radio.Group>
            </Form.Item>
          </Col> */}
          <Col span={8}>
            <Form.Item name="commission" label="Commission %">
              <InputNumber />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="gstNumber"
              label="GSTIN"
              rules={[
                {
                  max: 15,
                  message: "GSTIN should be maximum of 15 characters.",
                },
                {
                  pattern: new RegExp(
                    "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
                  ),
                  message: "GST number pattern not matching.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="panNumber"
              label="PAN Number"
              rules={[
                {
                  max: 10,
                  message: "PAN Number should be maximum of 10 characters.",
                },
                {
                  pattern: new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$"),
                  message: "PAN Number pattern not matching.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="stateCode"
              label="State Code"
              rules={[
                {
                  max: 50,
                  message: "State Code should be maximum of 50 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="bankDetails"
              label="Bank Details"
              rules={[
                {
                  max: 200,
                  message: "Bank Details should be maximum of 200 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="address"
              label="Address"
              rules={[
                {
                  max: 500,
                  message: "Address should be maximum of 500 characters.",
                },
              ]}
            >
              <TextArea showCount maxLength={500} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="generalInfo"
              label="General Info"
              rules={[
                {
                  max: 500,
                  message: "General Info should be maximum of 500 characters.",
                },
              ]}
            >
              <TextArea showCount maxLength={500} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="mobileNumber"
              label="Mobile Number"
              rules={[
                {
                  max: 15,
                  message: "Mobile Number should be maximum of 15 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="emailId"
              label="Email Ids(add multiple emails separted by ,)"
              rules={[
                {
                  max: 1000,
                  message: "Email Ids should be maximum of 1000 characters.",
                },
              ]}
            >
              <TextArea showCount maxLength={1000} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddAccount;
